<!--
    描述：菜单接口管理--左侧组织架构
    时间：2020-04-30
    Created by yefan
-->
<template>
	<div class="h100">
		<div class="w-table-layout">
			<div class="w-table-content"
				 ref="menusContent">
				<el-table :data="menusTreeData.tableData"
						  v-loading="menusTreeData.loading"
						  ref="menusTree"
						  default-expand-all
						  :height="menusTreeData.tableH"
						  border
						  highlight-current-row
						  @row-click="rowClick"
						  :tree-props="{children: 'children'}">
					<el-table-column prop="className"
									 label="类名"
									 show-overflow-tooltip
									 min-width="135"></el-table-column>
					<el-table-column prop="method"
									 label="方法名"
									 show-overflow-tooltip
									 min-width="90"></el-table-column>
					<el-table-column prop="name"
									 label="接口功能"
									 show-overflow-tooltip
									 min-width="100"></el-table-column>
					<el-table-column prop="url"
									 label="url"
									 show-overflow-tooltip
									 min-width="120"></el-table-column>
					<el-table-column prop="type"
									 label="接口请求方式"
									 align="center"
									 show-overflow-tooltip
									 min-width="70"></el-table-column>
					<el-table-column prop="projectName"
									 label="接口所属服务"
									 show-overflow-tooltip
									 min-width="70"></el-table-column>
					<el-table-column label="操作"
									 align="center"
									 show-overflow-tooltip
									 width="80">
						<template slot-scope="scope">
							<el-button v-if="roleBtns.includes('menu_interface_delete')"
									   size="mini"
									   icon="el-icon-delete"
									   title="删除"
									   type="text"
									   @click="doClick(scope.row,'delete')"></el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { getMenuInterfaceList } from 'api/system/sys.js'
import { deleteInfo } from 'api/system/menu.js'

export default {
	data() {
		return {
			searchObj: '',
			menusTreeData: {
				loading: false,
				tableH: 200,
				tableData: []
			}
		}
	},
	methods: {
		getMenuTreeTableData(searchObj) {
			let that = this
			that.searchObj = searchObj
			let param = {}
			param.name = searchObj.name
			param.menuId = searchObj.menuId

			getMenuInterfaceList(param).then(res => {
				//zwh-接口列表（不分页）
				that.menusTreeData.tableData = res.data
			})
		},

		rowClick(obj) {
			this.$emit('row-click', obj)
		},

		doClick(obj, type) {
			if (type == 'delete') {
				// 删除
				this.delete(obj)
			}
		},

		delete(obj) {
			let that = this
			this.$confirm('确认删除吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let param = {
					menuId: that.searchObj.menuId,
					interfaceId: obj.id
				}
				deleteInfo(param).then(res => {
					if (res.operationCode == 1) {
						that.$message({ message: '删除成功', type: 'success' })
						that.getMenuTreeTableData(that.searchObj)
					} else {
						that.$message({ message: res.msg, type: 'error' })
					}
				})
			})
		}
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.menusTreeData.tableH = this.$refs.menusContent.offsetHeight
			}, 100)
		})
	},
	// 进入缓存页面
	activated() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.menusTreeData.tableH = this.$refs.menusContent.offsetHeight
			}, 100)
		})
	},
	computed: {
		...mapState('app', { clientSize: state => state.clientSize }),
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		})
	},
	watch: {
		clientSize(val) {
			this.menusTreeData.tableH = this.$refs.menusContent.offsetHeight
		}
	}
}
</script>
